<template>
    <span v-if="order.id">
        <b-button
            v-b-modal="`order_send_modal_${order.id}`"
            :variant="buttonStyle.variant"
            :class="buttonStyle.class"
            :size="buttonStyle.size"
            v-b-tooltip.hover="title"
            @click="send"
        >
            <font-awesome-icon :icon="['fas', 'paper-plane']" />
            Send
        </b-button>
    </span>
</template>

<script>
import axios from "axios";

export default {
  name: "OrdersSendDialog",
  props: {
    order: {
      type: Object,
      default: null
    },
    buttonStyle: {
      type: Object,
      default: () => ({
        variant: "warning",
        class: "",
        size: ""
      })
    },
    title: {
      type: String,
      default: "Please Confirm"
    },
    isSent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sent: this.isSent,
      sending: false
    };
  },
  methods: {
    send() {
      this.$bvModal
        .msgBoxConfirm(this.$t("send_dialog_are_you_sure"), {
          title: this.$t("send_dialog_title", {
            po_number: this.order.po_number
          }),
          size: "md",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: this.$t("yes_send_now"),
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            this.sending = true;
            axios
              .put("/api/orders/" + this.order.id + "/send")
              .then(() => {
                this.sent = true;
                this.$emit("success", {
                  message: "The order has been sent."
                });
              })
              .catch(error => {
                let errorMessage = "Error while sending the order.";
                let customError = 0;
                if (
                  error.response.data.message ===
                  "Passport limit reached for this company."
                ) {
                  customError = 1;
                  errorMessage =
                    "You have reached the limit of passports you can generate. Please contact our services to unlock more passports !";
                }
                this.$emit("error", {
                  message: errorMessage,
                  errorCode: customError
                });
              })
              .finally(() => {
                this.sending = false;
              });
          }
        });
    }
  }
};
</script>
